import {
  SearchResultDto,
  SpecificFilterOption,
  SpecificFilterRow,
} from './types';

const createOriginatorAutocompleteOption = (item: SearchResultDto) => ({
  id: item.label ?? '',
  label: item.classLabel
    ? `${item.classLabel}: ${item.label ?? ''}`
    : item.label ?? '',
});

export const createOriginatorRelationFilterRow = (
  item: SearchResultDto,
  filterOption: SpecificFilterOption
): SpecificFilterRow => ({
  locked: true,
  negation: false,
  filterOption,
  customFilterValues: [
    {
      field: '',
      value: '',
    },
    {
      field: '',
      value: createOriginatorAutocompleteOption(item),
    },
    {
      field: '',
      value: '',
    },
  ],
});

export const createOriginatorGeneralFilterRow = (
  item: SearchResultDto,
  filterOption: SpecificFilterOption
): SpecificFilterRow => ({
  locked: true,
  negation: false,
  filterOption,
  customFilterValues: [
    {
      field: '',
      value: '',
    },
    {
      field: '',
      value: createOriginatorAutocompleteOption(item),
    },
    {
      field: '',
      value: '',
    },
  ],
});
